import { FC } from "react";

interface IconProps {
  color?: string;
}

const ChevronDown: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg viewBox="0 0 16 16" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.666 5.667 8 10.333 3.333 5.667"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default ChevronDown;
